(function () {
    'use strict';
    $(document).ready(function () {

        objectFitImages();

        const $dropdown = $('.dropdown');

        //footer dropdown slide
        $dropdown.on('show.bs.dropdown', function (e) {
            $(this).find('.dropdown-menu').first().stop(true, true).slideDown(300);
        });

        $dropdown.on('hide.bs.dropdown', function (e) {
            $(this).find('.dropdown-menu').first().stop(true, true).slideUp(200);
        });

        $(".aria-true").each(function () {
            $(this).attr('aria-expanded', 'true');
        });

        $("a[target='_blank']").each(function () {
            var title = $(this).attr('title');
            if (typeof title !== 'undefined' && title !== null) {
                //$(this).attr('title', 'Strona otworzy się w nowym oknie: ' + title);
            } else {
                $(this).attr('title', 'Strona otworzy się w nowym oknie');
            }
        });


        // Smooth scroll to
        $('.scroll-animation').on('click', function (e) {
            e.preventDefault();

            const href = $(this).attr('href');
            if (href) {
                $("html, body").animate({
                    scrollTop: $(href).offset().top
                }, 1000);
            }
            $(href).focus();
        });

        $('.scroll-animation a').on('click', function (e) {
            e.stopPropagation();
        });

        //Menu mobile toggle
        $(".menu-toggle").click(function(){
            $('.menu-overlay').slideToggle();
            $(this).toggleClass("open");
            $(this).attr('aria-expanded', function (i, attr) {
                return attr == 'true' ? 'false' : 'true'
            });
        });

        $("#site-menu li.menu-item-has-children > a").on('click', function (e) {
            e.preventDefault();
        });

        $("#site-menu li.menu-item-has-children > ul," +
            "#site-menu li.menu-item-has-children > ul > li").on('click', function (e) {
            e.stopPropagation();
        });

        $("#site-menu > li.menu-item-has-children").click(function () {
            $(this).siblings('li').children('ul').slideUp();
            $(this).siblings('li').removeClass('open');
            $("#site-menu").find("a").each(function(){
                if($(this).parent().hasClass('menu-item-has-children')){
                    $(this).attr('aria-expanded', false);
                }
            })
            $(this).toggleClass('open');
            if($(this).hasClass('open')){
                $(this).find(">a").attr('aria-expanded', true);
            }
            $(this).children('ul').slideToggle({
                start: function () {
                    $(this).css({
                        display: "flex"
                    })
                }
            });
        });
        //
        $("#site-menu > li.menu-item-has-children > ul > li.menu-item-has-children").click(function () {
            $(this).siblings('li').each(function(){
                $(this).removeClass('open');
                if($(this).parent().hasClass('menu-item-has-children')){
                    $(this).attr('aria-expanded', false);
                }
            });
            $("#site-menu > li.menu-item-has-children > ul a").each(function(){
                if($(this).parent().hasClass('menu-item-has-children')){
                    $(this).attr('aria-expanded', false);
                }
            });
            if ($(document).width() <= 1050) {
                $(this).siblings('li').children('ul').slideUp();
                if( $(this).hasClass('open')){
                    $(this).children('ul').slideUp();
                    $(this).removeClass('open');
                }else {
                    $(this).children('ul').slideDown();
                    $(this).toggleClass('open');
                }
            }
            else {
                $(this).siblings('li').children('ul').hide('slide');
                if( $(this).hasClass('open')){
                    $(this).children('ul').hide("slide");
                    $(this).removeClass('open').find('>a').attr('aria-expanded', false);
                }else {
                    $(this).children('ul').show("slide");
                    $(this).toggleClass('open').find('>a').attr('aria-expanded', true);
                }
            }
        });

        var toolsInitialWidth = $(".tools").width();
        $('.search-trigger').click(function(e){
            if($(".search-container").is(":visible")){
                $(".tools").animate({
                    width: toolsInitialWidth
                });
                $(".search-container").animate({
                    width: "0px"
                },200,function(){
                    $(".search-container").hide();
                });
                if($(document).width() < 700 && $(document).width() > 500) {
                    $(".header-top .report-name").fadeTo(300, 1);
                }
            }else {
                $(".tools").animate({
                    width: toolsInitialWidth + 200
                });
                if($(document).width() < 700) {
                    $(".header-top .report-name").fadeTo(300, 0);
                }
                $(".search-container").show();
                if($(document).width() < 500) {
                    $(".search-container").animate({
                        width: "160px"
                    });
                }else{
                    $(".search-container").animate({
                        width: "200px"
                    });
                }
                $('#search-input').focus();
            }
            e.preventDefault();
            return false;
        });

    });
}(jQuery));
